import { render, staticRenderFns } from "./GridsClear.vue?vue&type=template&id=458fed97&scoped=true"
import script from "./GridsClear.vue?vue&type=script&lang=js"
export * from "./GridsClear.vue?vue&type=script&lang=js"
import style0 from "./GridsClear.vue?vue&type=style&index=0&id=458fed97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458fed97",
  null
  
)

export default component.exports